import {
    Flex,
    Box,
    FormControl,
    FormLabel,
    Input,
    Stack,
    Button,
    Heading,
    Text,
    useColorModeValue,
    Link
  } from '@chakra-ui/react';
import { useState, FormEvent,  useEffect, useCallback } from 'react';
import {  useNavigate } from 'react-router-dom';
import { isAdmin, isLoggedIn, signIn } from '../fetch/auth';
import { useCurrentUser } from './user-context';
import { ROUTES } from '../routes';
import { setCaptinsLocally } from '../fetch/captins';
import { ApiError } from '../fetch';

export const SignInCard = () => {
  //useDocumentTitle('Sign in');
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState('');
  const { refreshCurrentUser } = useCurrentUser();

  const signin = useCallback(
    async (e: FormEvent | MouseEvent) => {
      e.preventDefault();
      try {
        await signIn(email,password);
        refreshCurrentUser();
        if (isAdmin()){
     
          setCaptinsLocally();
        }
        navigate(ROUTES.HOME);
      } catch (e) {
        setError((e as ApiError).message);
      }
    },
    [navigate, password, refreshCurrentUser, email]
  );

  useEffect(() => {
    if (isLoggedIn()) {
      navigate(ROUTES.HOME);
    }
  }, [navigate]);
  
 /*  export default function SignInCard() {

    const {setAuth}=useContext(AuthContext);


   async function handleSubmit(e: FormEvent | MouseEvent) {
        e.preventDefault();
        console.log('You clicked submit.');
        const request: signInRequest={
          email:email,
          password:password         
        }
        console.log(request);
       
                    
          setAuth(await SignIn(request));
      }*/
    return (
        <form onSubmit={signin} dir='rtl'>
      <Flex
        minH={'100vh'}
        
        justify={'center'}
        bg={useColorModeValue('gray.50', 'gray.800')}>
        <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12} px={6}>
          <Stack align={'center'}>
            <Heading fontSize={'4xl'}>تسجيل الدخول</Heading>
            <Text fontSize={'lg'} color={'gray.600'}>
             ✌️ برو إكسبريس
            </Text>
          </Stack>
          <Box
            rounded={'lg'}
            bg={useColorModeValue('white', 'gray.700')}
            boxShadow={'lg'}
            p={8}>
            <Stack spacing={4}>
              <FormControl id="email">
                <FormLabel>البريد الإلكتروني</FormLabel>
                <Input type="email" value={email} onChange={e => setEmail(e.target.value)}/>
              </FormControl>
              <FormControl id="password">
                <FormLabel>كلمة المرور</FormLabel>
                <Input type="password" value={password} onChange={e => setPassword(e.target.value)}/>
              </FormControl>
              <Stack spacing={10}>
  
                  <Link href={ROUTES.FORGOT_PASSWORD} color={'blue.400'}>نسيت كلمة المرور؟</Link>
            
                <Button
                type='submit' 
                  bg={'blue.400'}
                  color={'white'}
                  _hover={{
                    bg: 'blue.500',
                  }}>
                 تسجيل الدخول
                </Button>
                {!!error && <Text color="red.700">{error}</Text>}
              </Stack>
            </Stack>
          </Box>
        </Stack>
       
      </Flex>
      </form>
    );
  }